// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../Core.Generator/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".block_toggle .block__control_nav{display:flex;list-style:none;margin:0;padding:0}.block_toggle .block__control_nav .block__control_nav_item{background:transparent;color:var(--_core__button_background);display:block;padding:.25rem 1.5rem}.block_toggle .block__control_nav .block__control_nav_item.block__control_nav_item--active{background:var(--_core__button_background);color:var(--_core__button_color)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
